export class DtoAccion {
    Codigo: string = '';
    Descripcion: string = '';
}